import React, {useContext, useEffect, useState} from 'react';
import {theme} from '../../styles/darkTheme';
import {
  Container,
  HeaderContainer,
  PageName,
  DetailsContainer,
  Title,
  Subtitle,
  DataContainer,
  Button,
  IconButton,
  BackButtonContainer,
} from './styles';
import {useTranslation} from '../../context/language';
import Card from '../../components/atoms/Card';
import store from '../../redux/store';
import Logo from '../../components/atoms/Logo';
import RequestLogo from '../../assets/logos/request.svg';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {
  CLEAN_REMITTANCE,
  CLEAN_REMITTANCE_RESPONSE,
} from '../../redux/actionTypes';
import {getDate} from '../../utils/getters';
import {RootState} from '../../redux/reducers';
import {useQuery} from '../../hooks/useQuery';
import axios from '../../utils/axios';
import LoadingSpinner from '../../components/atoms/LoadingSpinner';
import BackArrow from '../../assets/icons/BackArrow.svg';
import {TabSwitchContext} from '../../context/tabSwtich';

interface RemittanceDetails {
  createdAt: any;
  receiving: any;
  description: string;
  name: any;
  countryCode: any;
  mobilePhone: any;
  id?: any;
  action?: any;
}

const RemittanceDetails = () => {
  const {title, text} = useTranslation();
  const {dialCountryCode, mobileNumber} = useSelector((state: RootState) => ({
    ...state.user,
  }));
  const {remittanceResponse, remittance} = store.getState();
  const {createdAt, extraInfo, description, id: resId } = remittanceResponse;
  const {receiving} = extraInfo;
  const {name, id, action} = remittance;
  const {dialCountryCode : countryCode, mobileNumber: mobilePhone } = remittance.senderPhone
  const history = useNavigate();
  const dispatch = useDispatch();
  const query = useQuery();
  const remittanceId = query.get('id') || id;
  const showId = query.get('id') || resId;
  const type = query.get('action') || action;

  const [currentRemittance, setCurrentRemittance] =
    useState<RemittanceDetails>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {setTabSwitch} = useContext(TabSwitchContext);

  const requestData = async (remittanceId: string) => {
    //console.log('remittanceId', remittanceId)
    const url = '/api/v1/remittance/widget/detail/';
    const data = {
      userPhone: {
        dialCountryCode,
        mobileNumber,
      },
      remittanceId,
    };
    try {
      setIsLoading(true);
      const res = await axios.post(url, data);

      const {createdAt, extraInfo, description, sender} = res.data.remittance;
      const {receiving} = extraInfo;
      const {firstName, lastName} = sender.profile;
      const {dialCountryCode, phoneNumber} = sender;
      setCurrentRemittance({
        createdAt: getDate(createdAt),
        receiving: getReceivingAmount(receiving),
        description,
        name: `${firstName} ${lastName}`,
        countryCode: dialCountryCode,
        mobilePhone: phoneNumber,
      });
      setIsLoading(false);
    } catch (e) {
      console.log(JSON.stringify(e, null, 4));
      setCurrentRemittance({
        createdAt: '',
        receiving: '',
        description: '',
        name: '',
        countryCode: '',
        mobilePhone: '',
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!remittanceId) {
      return setCurrentRemittance({
        createdAt: getDate(createdAt),
        receiving: getReceivingAmount(receiving),
        description,
        name,
        countryCode: `+${countryCode}`,
        mobilePhone,
      });
    }
    (async () => requestData(remittanceId))();
  }, []);

  const getReceivingAmount = (receiving: any) => {
    return `${Number(receiving.amount).toFixed(2)} ${String(
      receiving.currency,
    )}`;
  };

  const handleClickContinue = () => {
    dispatch({type: CLEAN_REMITTANCE});
    dispatch({type: CLEAN_REMITTANCE_RESPONSE});
    history('/chats');
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Container>
      {remittanceId && (
        <BackButtonContainer onClick={() =>{
          setTabSwitch(false)
          history(-1)
        }}>
          <IconButton src={BackArrow} size={24} />
        </BackButtonContainer>
      )}
      <HeaderContainer top={remittanceId ? 5 : 25}>
        <PageName theme={theme}>{title.remittanceDetails}</PageName>
      </HeaderContainer>
      <Logo src={RequestLogo} height={130} width={130} />
      <DetailsContainer>
        <Title theme={theme}>{type === 'remittance' ? text.receivedRemittance : text.remittanceRequested}</Title>
        <Subtitle
            theme={theme}
            weight={'normal'}
            size={'18px'}
            top={'15px'}
            color={theme.darkText}
        >ID: {showId}</Subtitle>
        <Subtitle theme={theme}>{currentRemittance?.createdAt}</Subtitle>
        <Subtitle
          theme={theme}
          weight={'normal'}
          size={'18px'}
          top={'15px'}
          color={theme.darkText}>
          {type === 'remittance' ? '' : text.tigoSMS}
        </Subtitle>
        {/* <StatusContainer>
          <Logo src={PendingLogo} height={20} width={20} />
          <StatusText theme={theme}>Pendiente</StatusText>
        </StatusContainer> */}
      </DetailsContainer>
      <DataContainer theme={theme}>
        <Card
          label={type === 'remittance' ? text.receivedAmountRemittance : text.requestedAmountRemittance}
          value={currentRemittance?.receiving}
          valueColor={theme.background}
          clear
        />
        <Card
          label={ type === 'remittance' ? text.sender : text.requesterRemittance}
          value={currentRemittance?.name}
          valueColor={theme.background}
          valueSize={'24px'}
          clear
        />
        <Card
          value={`🇺🇸 ${String(currentRemittance?.countryCode)} ${String(
            currentRemittance?.mobilePhone,
          )}`}
          valueSize={'24px'}
          valueColor={theme.background}
          clear
        />
        {currentRemittance?.description &&
          currentRemittance.description !== '' && (
            <Card
              label={text.noteRemittance}
              value={currentRemittance?.description}
              valueSize={'24px'}
              valueColor={theme.background}
              clear
            />
          )}
        {!remittanceId && (
          <Button onClick={handleClickContinue}>{text.continue}</Button>
        )}
      </DataContainer>
    </Container>
  );
};

export default RemittanceDetails;
